//LOCALHOST
//export const SERVER_URL = 'https://rastreamento.jotagro.com.br:5020';

//PRO (antiga)
//export const SERVER_URL = 'http://ahura.online:3009';

//DEV
//export const SERVER_URL = 'https://api-dev.ahura.online';

//HOM
//export const SERVER_URL = 'https://api-hom.ahura.online';

//PRO 
export const SERVER_URL = 'https://www.rastreiesuafrota.com.br:2001'

//HOM & PRO
//export const API_KEY = 'AIzaSyD2J7qcppxvELMKI_HlJjtTaevFci_EuEU';

//export const API_KEY = 'AIzaSyBSITs_HaOlGZZx7L3rpA-Wz2n7uXr-no0';

//LOCAL
export const API_KEY = 'AIzaSyCR1JAhPxw0UMK04EV-buHcKL4_c2ku2G4';



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/services/server-url.ts